import { Component, OnInit, AfterViewInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { RightMenuService } from 'src/app/services/right-menu/right-menu.service';

@Component({
  selector: 'app-vertical',
  templateUrl: './vertical.component.html',
  styleUrls: ['./vertical.component.scss']
})

/**
 * Vertical component
 */
export class VerticalComponent implements OnInit, AfterViewInit {

  isCondensed = false;

  constructor(
    public rightMenuService: RightMenuService,
    private router: Router
  ) {
    router.events.forEach((event) => {
      if (event instanceof NavigationEnd) {
        document.body.classList.remove('sidebar-enable');
      }
    });
  }

  ngOnInit() {
    document.body.removeAttribute('data-layout');
    document.body.removeAttribute('data-topbar');
    document.body.removeAttribute('data-layout-size');
    document.body.classList.remove('sidebar-enable');
    document.body.classList.remove('auth-body-bg');
    document.body.classList.remove('vertical-collpsed');
    document.body.removeAttribute('data-sidebar-size');
  }

  isMobile() {
    const ua = navigator.userAgent;
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|mobile|CriOS/i.test(ua);
  }

  ngAfterViewInit() {
  }

  /**
   * on settings button clicked from topbar
   */
  onSettingsButtonClicked() {
    document.body.classList.toggle('right-bar-enabled');
  }

  /**
   * On mobile toggle button clicked
   */
  onToggleMobileMenu() {
    this.isCondensed = !this.isCondensed;

    this.rightMenuService.currentMenuItem = undefined;

    document.body.classList.toggle('sidebar-enable');
    document.body.classList.toggle('vertical-collpsed');

    this.rightMenuService.toggleMenu = !this.rightMenuService.toggleMenu;
    this.rightMenuService.toggleMenuObservable?.next(
      this.rightMenuService.toggleMenu
    );

    if (window.screen.width <= 768) {
      document.body.classList.remove('vertical-collpsed');
      // this.rightMenuService.toggleMenu = false;
    }
  }
}
